import React from "react";
import {
  Box,
  Card,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Divider
} from "@mui/material";

const border = "1px solid #dcdcdc";
const label = { fontWeight: 600 };
const sectionHeader = {
  backgroundColor: "#f3f6f9",
  fontWeight: 700
};

const AssessorSummaryNC = ({ data }) => {
  if (!data || data.length === 0) return null;

  return (
    <Box sx={{ mb: 4 }}>
      <Card elevation={3}>
        {/* HEADER */}
        <Box
          sx={{
            background:
              "linear-gradient(135deg, #42275a 0%, #734b6d 100%)",
            color: "#fff",
            textAlign: "center",
            py: 2
          }}
        >
          <Typography variant="h6" fontWeight={700}>
            ASSESSOR'S SUMMARY ON NON-CONFORMITY
          </Typography>
        </Box>

        <TableContainer component={Paper}>
          <Table size="small">
            <TableBody>
              {data.map((nc, index) => (
                <React.Fragment key={index}>
                  {/* ASSESSOR DETAILS */}
                  {nc.assrRow === "1" && (
                    <>
                      <TableRow sx={sectionHeader}>
                        <TableCell colSpan={5} sx={border}>
                          Assessor Details
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell colSpan={2} sx={{ border, ...label }}>
                          Assessor
                          <Typography variant="body2">{nc.Name}</Typography>
                        </TableCell>

                        <TableCell colSpan={2} sx={{ border, ...label }}>
                          Assessment Dates
                          <Typography variant="body2">{nc.Dates}</Typography>
                        </TableCell>

                        <TableCell sx={{ border, ...label }}>
                          Capacity
                          <Typography variant="body2">{nc.Capacity}</Typography>
                        </TableCell>
                      </TableRow>
                    </>
                  )}

                  {/* NC HEADER */}
                  <TableRow sx={sectionHeader}>
                    <TableCell colSpan={5} sx={border}>
                      Non-Conformity Details (NC No: {nc.rowNo})
                    </TableCell>
                  </TableRow>

                  {/* BASIC INFO */}
                  <TableRow sx={{ pageBreakInside: "avoid" }}>
                    <TableCell sx={{ border }}>
                      <strong>Date</strong>
                      <Typography variant="body2">{nc.Date}</Typography>
                    </TableCell>

                    <TableCell sx={{ border }}>
                      <strong>NC No</strong>
                      <Typography variant="body2">{nc.rowNo}</Typography>
                    </TableCell>

                    <TableCell colSpan={3} sx={{ border }}>
                      <strong>Activity Assessed</strong>
                      <Typography variant="body2">
                        {nc.SubCategory}
                      </Typography>
                    </TableCell>
                  </TableRow>

                  {/* NC RAISED */}
                  <TableRow>
                    <TableCell colSpan={5} sx={{ border }}>
                      <Typography fontWeight={600} color="error.main">
                        NON-CONFORMITY RAISED
                      </Typography>
                      <Typography variant="body2" color="error">
                        {nc.AnsRemarks}
                      </Typography>
                    </TableCell>
                  </TableRow>

                  {/* STANDARD & CLASSIFICATION */}
                  <TableRow sx={{ backgroundColor: "#fafafa" }}>
                    <TableCell colSpan={5} sx={{ border }}>
                      <strong>{nc.NC_Standard}</strong>{" "}
                      {nc.NC_Clause}
                    </TableCell>
                  </TableRow>

                  {/* LAB CORRECTIVE ACTION */}
                  <TableRow>
                    <TableCell colSpan={5} sx={{ border }}>
                      <Typography fontWeight={600} color="primary.main">
                        {nc.lblCAPBTL ||
                          "CORRECTIVE ACTION PROPOSED BY LABORATORY"}
                      </Typography>
                      <Typography variant="body2" color="primary">
                        {nc.VerificationRemarks}
                      </Typography>
                    </TableCell>
                  </TableRow>

                  {/* DIVIDER BETWEEN NCs */}
                  <TableRow>
                    <TableCell colSpan={5} sx={{ p: 0 }}>
                      <Divider sx={{ my: 2 }} />
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );
};

export default AssessorSummaryNC;
